module.exports = __webpack_public_path__ + "static/media/Neo-Sans-Pro.baf7b105.ttf";